import React from 'react';
import { StatisticsLayout } from 'views/components';
import { Table } from 'mol-ui';
import { isLocked } from 'shared/utils';
import { statisticsActions } from 'core/Statistics';
import { useTranslation } from 'react-i18next';
import { TABLE, downloadHeaders } from './fixtures';
import {
    useDispatch,
    useSelector
} from 'hooks';

const StatisticsProfessionals = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { user } = useSelector('account');
    const {
        loading,
        professionalsDownload,
        professionalsDownloading,
        professionals: professionalsStatistics
    } = useSelector('statistics');

    const onFiltersChange = filters => {
        dispatch(statisticsActions.getStatisticsProfessionals(filters));
    };

    const downloadController = {
        data: professionalsDownload,
        downloading: professionalsDownloading,
        headers: downloadHeaders.filter(({ hidden }) => !hidden),
        onDownload: filters => dispatch(statisticsActions.getStatisticsProfessionalsDownload(filters))
    };

    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            loading={ loading }
            title={ t('Profesionales') }
            onFiltersChange={ onFiltersChange }
        >
            {
                !!professionalsStatistics &&
                <Table
                    config={ TABLE }
                    data={ professionalsStatistics }
                />
            }
        </StatisticsLayout>
    );

};

StatisticsProfessionals.propTypes = {

};

export default StatisticsProfessionals;
